export const ViewTicketsConstants = { 
	SEARCH_NAME: "ViewCosmicTickets", 
	PAGE_SIZE: 5 
}; 
